import { clearListCache } from "../../shared/lib/cache/listCache";
import { clearAllAccountContext } from "../../shared/lib/auth/accountContext";
import { clearUserAttributesCache } from "./authSessionAttributes";
import { clearRecentlyConfirmedEmail } from "./emailVerificationOverride";
import use123zapStore from "../../stores/123zapStore";
import useAccountSettingsStore from "../../features/account/store/useAccountSettingsStore";
import { setLastKnownAuth } from "./authStorage";

function resetZustandSessionState() {
  use123zapStore.getState().resetSessionState();
  useAccountSettingsStore.getState().resetAccountSettingsState();
}

export function markSessionAuthenticated(user) {
  setLastKnownAuth(true);
  use123zapStore
    .getState()
    .setFinishedRegister(user?.completeProfile ?? null);
}

export function markSessionUnauthenticated({ clearPlan = false } = {}) {
  setLastKnownAuth(false);
  clearAllAccountContext();

  if (clearPlan) {
    use123zapStore.getState().clearPlanoAtual();
  }

  resetZustandSessionState();
}

export function clearSessionProfileState() {
  use123zapStore.getState().setFinishedRegister(null);
}

export function clearSignInSessionCache() {
  clearUserAttributesCache();
  clearRecentlyConfirmedEmail();
}

export function clearLogoutSessionCache() {
  clearUserAttributesCache();
  clearRecentlyConfirmedEmail();
  clearListCache();
  resetZustandSessionState();
}
